import { useNavigate, useLocation } from 'react-router-dom';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Link na sekciju početne stranice; radi i kad se klikne sa druge stranice.
export default function AnchorLink({ href, onClick, children, ...props }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    onClick?.();
    if (pathname === '/') {
      document
        .querySelector(href)
        ?.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    } else {
      navigate(`/${href}`);
    }
  };

  return (
    <a href={href} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
